/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {NavbarComponent as ɵa} from './src/components/navbar/navbar.component';
export {SidenavComponent as ɵb} from './src/components/sidenav/sidenav.component';